import { useResource } from 'app/common/api';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';

import { logoutRequest } from '../requests/logout.request';

export const useLogout = () => {
  const errorNotify = usePageNotify();

  const resource = useResource<void, void>({
    request: logoutRequest,
    errorNotify,
    onAuthRequired(error) {
      errorNotify.addMessage({ type: 'error', message: error.message });
    },
    onDone() {
      window.location.replace('/');
    },
  });

  return resource;
};
